import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import type { OrderNumberTaken } from '../orderProductSaveErrors';

interface OrderNumberTakenHelpProps {
  taken: OrderNumberTaken;
}

/**
 * Field message of „Edytuj numer” when another order already has the number
 * (400 ORDER_NUMBER_TAKEN). The number links to that order in a new tab, so the
 * operator can renumber it and come back; without `orderId` (no access) it is
 * plain text.
 */
const OrderNumberTakenHelp: React.FC<OrderNumberTakenHelpProps> = ({ taken }) => {
  const { t } = useTranslation(['orders']);
  if (taken.number && taken.orderId) {
    return (
      <Trans
        t={t}
        i18nKey="orders:error.orderNumberTakenLinked"
        values={{ number: taken.number }}
        components={{
          orderLink: (
            <Link
              to={`/app/orders/${encodeURIComponent(taken.orderId)}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="order-number-taken-link"
            />
          ),
        }}
      />
    );
  }
  return (
    <>
      {taken.number
        ? t('orders:error.orderNumberTaken', { number: taken.number })
        : t('orders:error.orderNumberTakenUnnamed')}
    </>
  );
};

export default OrderNumberTakenHelp;
